import React, {useEffect, useState} from 'react';
import {Table, Icon, Input, DatePicker, Button, Balloon, Select} from "@alifd/next";
import style from './index.module.scss';
import moment from 'moment';
import LzPagination from '@/components/common/LzPagination';
import { Servlets } from '@/service';
import CreateSmsTemplate from '../CreateSMSTemplate';
import LzMsg from '@/components/common/LzMsg';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';


const { RangePicker } = DatePicker;
const CustomDefinition = ():JSX.Element => {
  let defaultParams = {
    templateName: '', // 模板名称
    templateContent:'',//短信模板内容
    createTimeStr: '', // 创建时间开始
    createTimeEnd: '', // 创建时间 结束
    modelTypeCode:'',//模板类型
  }
  //刷新列表
  const [refreshList,setRefreshList] = useState(false);
  // 短信签名
  const [sign, setSign] = useState('');
  //新建短信模板弹窗
  const [dialogVisible,setDialogVisible] = useState(false);
  //短信模板删除弹窗
  const [deleteVisible,setDeleteVisible] = useState(false);
  // 删除id
  const [deleteId, setDeleteId] = useState();
  // 查询信息
  const [searchParams, setSearchParams] = useState(defaultParams);
  // 翻页信息
  const [searchParams1, setSearchParams1] = useState(defaultParams);
  // 列表loading
  const [listLoading,setListLoading] = useState(false);
  // 短信模板列表数据
  const [tableData, setTableData] = useState([]);
  // 任务列表分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  const [selectDataList, setSelectDataList] = useState([{
    label:'全部',
    value:''
  }])
  const defaultTimeValues = [
    moment("00:00:00", "HH:mm:ss", true),
    moment("23:59:59", "HH:mm:ss", true)
  ];
  const changeTime = (v) => {
    let startTime = '';
    let endTime = '';
    startTime = v[0]?moment(v[0]).format('YYYY-MM-DD HH:mm:ss'):'';
    endTime = v[1]?moment(v[1]).format('YYYY-MM-DD HH:mm:ss'):'';
    setSearchParams({...searchParams,createTimeStr:startTime,createTimeEnd:endTime})
  }
  const getSign = () => {
    Servlets('getTitle', {}).then((res: any) => {
        console.log('res', res);
        if (!res.success) {
          LzMsg.error(res.resp_msg);
        } else{
          const { shopName } = res.data;
          Servlets('getSmssign', { shopName }).then((res: any) => {
            console.log('res', res);
            if (!res.success) {
              LzMsg.error(res.resp_msg);
            } else{
              setSign(res.data);
            }
          }).catch((e) => {
            console.log('edddddd', e);
            LzMsg.error('获取签名失败！');
          })
        }
      }).catch((e) => {
      console.log('edddddd', e);
      LzMsg.error('获取签名失败！');
    });
  }
  const searchList = (v) => {
    setListLoading(true);
    let params = {
      templateName: searchParams.templateName ? searchParams.templateName : '', // 模板名称
      templateContent:searchParams.templateContent ? searchParams.templateContent : '',//关键字
      createTimeStr: searchParams.createTimeStr ? moment(searchParams.createTimeStr).format('x'):'', // 创建时间开始
      createTimeEnd: searchParams.createTimeEnd ? moment(searchParams.createTimeEnd).format('x'):'', // 创建时间 结束
      modelTypeCode:searchParams.modelTypeCode,//模板类型
      templateType: 0, // 模板类型 0-自定义模板 1-系统模板
      pageNo: 1,
      pageSize: pageInfo.pageSize,
      ...v
    }
    Servlets('getDouDianSMS', params).then((res) => {
      setTableData(res.data);
      setPageInfo({
        ...pageInfo,
        pageNo: res.page.pageNo,
        pageSize: res.page.pageSize,
        total: res.page.total,
      });
      setListLoading(false);
      console.log(res)
    }).catch((e) => {
      console.log(e);
      setListLoading(false);
    })
  }
  // 翻页
  const handlePageSizeChange = async (pages = {}) => {
    try {
      setPageInfo({
        ...pageInfo,
        ...pages,
      });
      searchList({
        templateName: searchParams1.templateName ? searchParams1.templateName : '', // 模板名称
        templateContent:searchParams1.templateContent ? searchParams1.templateContent : '',//关键字
        createTimeStr: searchParams1.createTimeStr ? moment(searchParams1.createTimeStr).format('x'):'', // 创建时间开始
        createTimeEnd: searchParams1.createTimeEnd ? moment(searchParams1.createTimeEnd).format('x'):'', // 创建时间 结束
        modelTypeCode:searchParams1.modelTypeCode,//模板类型 1-营销-人群营销官方版 2-通知-订单催付
        pageNo: pages.pageNo,
        pageSize: pages.pageSize
      });
    } catch (e) {
      console.log(e);
    }
  }
  const resetList = () => {
    setSearchParams(defaultParams);
    setSearchParams1(defaultParams);
    searchList({
      templateName: '', // 模板名称
      templateContent:'',//关键字
      createTimeStr:'', // 创建时间开始
      createTimeEnd:'', // 创建时间 结束
      modelTypeCode:'',
      pageNo: 1,
      pageSize: 10
    });
  }
  const deleteTemplate = (id) => {
    let params = {
      templateId:id
    }
    Servlets('smsTemplateDelete', params).then((res) => {
      if(res.data) {
        LzMsg.success('删除成功！');
        searchList({
          pageNo: 1,
          pageSize: pageInfo.pageSize
        });
      }
    }).catch((e) => {
      console.log(e);
    })
  }
  const getSmsModelTypeList = () => {
    Servlets('getSmsModelTypeList', {}).then((res) => {
      if(res.data) {
        let newSelectDataList = [...selectDataList]
        res.data.forEach((item)=>{
          newSelectDataList.push({
            label:item.typeName,
            value:item.typeCode,
          })
        })
        setSelectDataList(newSelectDataList)
      }
    }).catch((e) => {
      console.log(e);
    })
  }
  // 初始化
  useEffect(() => {
    getSmsModelTypeList();
    searchList({
      pageNo: 1,
      pageSize: pageInfo.pageSize
    });

  }, [])
  useEffect(()=>{
    if(refreshList) {
      searchList({
        pageNo: 1,
        pageSize: pageInfo.pageSize
      });
      setRefreshList(false);
    }
  },[refreshList])
  useEffect(()=>{
    getSign();
  },[sign])
  return (
    <>
      <div className={style.customDefinition}>
        <div className={style['search-box']}>
          <div className={style['search-small-box']}>
            <span>模板名称：</span>
            <Input
              name="templateName"
              placeholder="请输入模板名称"
              style={{width:'74%'}}
              value={searchParams.templateName}
              onChange={(v)=>{setSearchParams({...searchParams,templateName:v})}}
            />
          </div>
          <div className={style['search-small-box']}>
            <span>关键字：</span>
            <Input
              name="templateContent"
              placeholder="请输入关键字"
              style={{width:'74%'}}
              value={searchParams.templateContent}
              onChange={(v)=>{setSearchParams({...searchParams,templateContent:v})}}
            />
          </div>
          <div className={style['search-small-box']}>
            <span>创建时间：</span>
            <RangePicker
              name="createTime"
              showTime={{ defaultValue: defaultTimeValues, format: 'HH:mm:ss' }}
              onChange={changeTime}
              value={[searchParams.createTimeStr,searchParams.createTimeEnd]}
            />
          </div>
          <div className={style['search-small-box1']}>
            <span>模板类型：</span>
            <Select
              name="modelTypeCode"
              placeholder="请输入关键字"
              style={{width:'74%'}}
              value={searchParams.modelTypeCode}
              onChange={(v)=>{setSearchParams({...searchParams,modelTypeCode:v})}}
              dataSource={selectDataList}
            />
          </div>
          <div className={style['search-small-box2']}>
            <Button
              type='primary'
              className={`${style.w88} ${style.mr10}`}
              onClick={()=>{
                searchList({ pageNo: 1 });
                setSearchParams1({...searchParams});
              }}
            >
              查询
            </Button>
            <Button
              type='normal'
              className={style.w88}
              onClick={resetList}
            >
              重置
            </Button>
          </div>
        </div>
        <div className={style.card}>
          <div  className={style.newCreate}>
            <Button
              type="primary"
              onClick={()=>{
                if(sign){
                  setDialogVisible(true)
                } else {
                  LzMsg.error('签名获取失败，请检查签名状态！');
                }
              }}
            >
              +新建短信模板
            </Button>
          </div>
          <div className={style.table}>
            <Table dataSource={tableData} loading={listLoading}>
              <Table.Column title="模板名称" dataIndex="templateName" width={200} />
              <Table.Column title="短信类型" dataIndex="channelType" width={100} />
              <Table.Column
                title="模板类型"
                width={135}
                cell={(value, index, record)=>{
                  return (
                    <div>{record.modelTypeCode && selectDataList.filter((item)=>item.value === record.modelTypeCode)[0] ? selectDataList.filter((item)=>item.value === record.modelTypeCode)[0].label: ''}</div>
                  )
                }}
              />
              <Table.Column
                title="创建时间"
                width={160}
                cell={(value, index, record)=>{
                  return (
                    <div>{record.createTime ? moment(record.createTime).format('YYYY-MM-DD HH:mm:ss') : ''}</div>
                  )
                }}
              />
              <Table.Column
                title="短信内容"
                cell={(value, index, record) => {
                  return (
                    <div>
                      <span>{`【${sign}】${record.templateShowContent}`}</span>
                      <Balloon
                        trigger={
                          <Button type='primary' text className={style.ml5}>
                            <div style={{height:'12px',lineHeight:'8px'}}>详情</div>
                          </Button>}
                        closable={false}
                        align="t"
                        popupClassName={style.pop}
                      >
                        {`【${sign}】${record.templateShowContent}`}
                      </Balloon>
                    </div>
                  )
                }}
              />
              <Table.Column
                title="字数/计费条数"
                width={120}
                dataIndex='smsSplitNum'
              />
              {/* <Table.Column title="发送次数" dataIndex="count" width={90} /> */}
              <Table.Column
                title="状态"
                width={115}
                dataIndex="status"
                cell={(value, index, record) => {
                  if(record.status === 3) {
                    return (<div className={style.success_color}>审核成功</div>)
                  } else if(record.status === 2) {
                    return (
                      <Balloon.Tooltip
                        align="t"
                        closable={false}
                        trigger={
                          <div style={{display:'flex',alignItems:'center'}}>
                            <div className={style['red-text']} >审核失败</div>
                            <span
                              style={{
                                fontSize: '16px',
                                marginLeft: '4px',
                                cursor: 'pointer',
                              }}
                              className="iconfont icon-icon4-33"
                            />
                          </div>
                        }
                      >
                        <div>
                          {record.statusRemark? record.statusRemark : ''}
                        </div>
                      </Balloon.Tooltip>
                    )
                  } else {
                    return (<div>审核中</div>)
                  }
                }}
              />
              <Table.Column
                title="操作"
                width={80}
                dataIndex="Status"
                cell={(value, index, record) => {
                  return(
                    <div>
                      <Button
                        type='primary'
                        text
                        onClick={()=>{setDeleteId(record.templateId);setDeleteVisible(true)}}
                      >
                        删除
                      </Button>
                    </div>
                  )
                }}
              />
            </Table>
            <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
          </div>
        </div>
        {
          dialogVisible &&
          <CreateSmsTemplate
            dialogVisible={dialogVisible}
            setDialogVisible={(v)=>{setDialogVisible(v)}}
            setRefreshList={(v)=>{setRefreshList(v)}}
          />
        }
        { deleteVisible &&
          <ConfirmDialog
            promptInfo='是否确认删除当前模板'
            title="提示"
            flag={deleteVisible}
            confirmHandel={() => {
              setDeleteVisible(false);
              deleteTemplate(deleteId);
            }}
            cancelHandel={() => {
              setDeleteVisible(false);
            }}
          />
        }
      </div>
    </>
  )
}

export default CustomDefinition;
